<template>
  <div class="doc-problems-icon">
    <svg
      :id="`doc-problems-icon-${iconKey}`"
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125"
        stroke="#FF238D"
        stroke-width="2"
      />
    </svg>
    <b-popover :triggers="getPopoverType()" placement="bottom" :target="`doc-problems-icon-${iconKey}`">
      {{ data.docsTrouble }}
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "doc-problems-icon",
  props: ["data", "iconKey"],
  methods: {
    getPopoverType() {
      const bodyWidth = document.body.clientWidth;
      if (bodyWidth < 768) {
        return "click blur";
      }
      return "hover";
    },
  },
};
</script>
<style lang="scss" scoped>
.doc-problems-icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
